// extracted by mini-css-extract-plugin
export default {"wrapper":"Payment_wrapper__4cb6l","section":"Payment_section__ZGuiZ"};